import 'mdb-react-ui-kit/dist/css/mdb.min.css';
import "@fortawesome/fontawesome-free/css/all.min.css";
import Index from './Routes/Index';
import './styles/custom.css';
import './styles/editor.css';
import './styles/file-upload.css';
import './styles/file-upload.min.css.map';
import { LoadingOverlayProvider } from './Context/LoadingOverlayContext';
import { UserProvider } from './Context/UserContext';
import { DomainProvider } from './Context/DomainContext';
import { SidebarProvider } from './Context/SidebarContext';
import { SidebarPermissionProvider } from './Context/SidebarPermissionContext';
import { TranslationProvider } from './Context/TranslationContext';
import { NotificationProvider } from './Context/NotificationContext';
import { ToastProvider } from './Context/ToastContext';
import { IdleTimerProvider } from './Context/IdleTimerContext_v1';
import { ThemeProvider } from "./Context/ThemeContext";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import Watermark from './Components/Watermark/Watermark';
import { NoIndexForStaging } from './Components/Seo';

const getWatermarkConfig = () => {
    const env = process.env.REACT_APP_ENV || process.env.NODE_ENV || 'development';
    
    const envText = `Environment = ${env.toUpperCase()}`;
    
    switch(env?.toLowerCase()) {
        case 'development':
        case 'dev':
            return { 
                text: envText, 
                color: '#000000', 
                opacity: 0.20,
                show: true
            };
        case 'staging':
        case 'stage':
            return { 
                text: envText, 
                color: '#000000', 
                opacity: 0.20,
                show: true
            };
        case 'production':
        case 'prod':
            return { 
                text: envText, 
                color: '#000000', 
                opacity: 0.18,
                show: false
            };
        default:
            return { 
                text: envText, 
                color: '#000000', 
                opacity: 0.20,
                show: true
            };
    }
};

function App() {
  const watermarkConfig = getWatermarkConfig();
  
  return (
    <div className="app-container">
      <BrowserRouter>
        <UserProvider>
          <ThemeProvider>
            <HelmetProvider>
              <NoIndexForStaging />
              <SidebarProvider>
                <DomainProvider>
                  <LoadingOverlayProvider>
                    <SidebarPermissionProvider>
                      <TranslationProvider>
                        <NotificationProvider>
                          <ToastProvider>
                            <IdleTimerProvider>
                              <Index />
                            </IdleTimerProvider>
                          </ToastProvider>
                        </NotificationProvider>
                      </TranslationProvider>
                    </SidebarPermissionProvider>
                  </LoadingOverlayProvider>
                </DomainProvider>
              </SidebarProvider>
            </HelmetProvider>
          </ThemeProvider>
        </UserProvider>
      </BrowserRouter>
      {watermarkConfig.show && (
        <Watermark 
            text={watermarkConfig.text}
            opacity={watermarkConfig.opacity}
            angle={0} 
            fontSize="14px" 
            color={watermarkConfig.color}
            spacing={250} 
        />
      )}
    </div>
  );
}

export default App;
